<template>
  <div v-if="hasComments || canCreateComment" class="comments-section" :class="{ selected: selectedMobileOption == 'comments' }">
    <div id="header">
      <h3>Discussion</h3>
    </div>
    <async-block :loading="loading">
      <comment-list :tribute-options="tributeOptions"></comment-list>
      <comment-editor
        class="editor"
        ref="commentEditorOverview"
        name="comment[content]"
        commentable-type="Item"
        :tribute-options="tributeOptions"
        v-if="canCreateComment"
      />
    </async-block>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CommentList from "@cmp/comments/comment_list";
import CommentEditor from "@cmp/comments/comment_editor";

export default {
  components: { CommentList, CommentEditor },
  data: function () {
    return {
      loading: true,
      tributeOptions: {
        values: function(text, cb) { this.getUserNames(text, users => cb(users)); }.bind(this),
        lookup: "name",
        fillAttr: "name",
        noMatchTemplate: function () { return '<span style:"visibility: hidden;"></span>'; },
        menuItemLimit: 10
      }
    };
  },
  created: function () {
    const vm = this;
    vm.$store
      .dispatch("getItemComments", vm.item.id)
      .then(() => (vm.loading = false))
      .catch(() => (vm.loading = false));
  },
  computed: {
    ...mapState(['comments', 'item', 'selectedMobileOption']),
    canCreateComment: function () {
      if (this.$root.userLoggedIn) {
        return true;
      } else if (this.item.attributes.allow_anonymous_comments) {
        return true;
      } else {
        return false;
      }
    },
    hasComments: function () {
      return this.comments && this.comments.length;
    },
  },
  methods: {
    getUserNames: function(query, callback) {
      if(!this.$root.userLoggedIn || query.length < 2) return callback([]);

      this.$store.dispatch('searchUsers', { params: { q: query } })
      .then(function (response) {
        let returnValue = [];
        for (const user of response["data"]["data"]["results"]["attributes"]["users"]) {
          returnValue.push(user);
        }
        callback(returnValue);
      });
    },
  }
};
</script>

<style lang="scss">
@import "../../../packs/application.scss";

.comments-section {
  text-align: left;
  color: $dark-gray;
  padding: 0 40px;
}

.no_comment_section {
  background: $white;
  text-align: center;
  padding: 2rem;

  .no_comments {
    padding: 2rem;
    text-align: center;
  }

  .no_comment_heading {
    color: $warm-gray;
    padding: 0.5rem 0rem;
    font-size: 1.2rem;
  }

  .no_comment_text {
    color: $warm-gray;
    font-size: 0.7rem;
  }
}

#header {
  margin-bottom: 1rem;
}

h3 {
  font-size: 1.25rem;
}

@media (max-width: 767px) {
  #header { display: none; }
  .comments-section {
    display: none;
    text-align: left;
    padding: 0;

    &.selected {
      display: block;
    }
  }
}
</style>
